import { initiateAuthentication } from '@/lib/auth-client'
import { emitSessionExpired } from './session-events'

let authTransitionInFlight = false
let redirectInProgress = false

export const beginAuthTransition = () => {
  authTransitionInFlight = true
}

export const isAuthTransitionInFlight = () => authTransitionInFlight

const isTauriDesktop = () =>
  typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window

export const redirectToLogin = async () => {
  if (redirectInProgress) return
  redirectInProgress = true
  authTransitionInFlight = true
  try {
    if (isTauriDesktop()) {
      emitSessionExpired()
      return
    }
    const redirectUrl = import.meta.env.VITE_REDIRECT_URL as string
    const loginUrl = await initiateAuthentication(redirectUrl)
    if (loginUrl?.redirectUrl) {
      window.location.href = loginUrl.redirectUrl
    }
  } catch {
    // Do not reset — prevents retry storms on repeated 401s
  }
}

export const redirectToCityClerkDashboard = (): void => {
  if (typeof window !== 'undefined') {
    window.location.href = '/city-clerk/dashboard'
  }
}
